
var lodash = require('lodash');
var flowplayer = require('flowplayer');
var audioplugin = require('./flowplayer.audio');
var swiper = require('swiper');
var quizSettings = require('./quiz_settings');
var chapterQuizSettings = require('./chapter_quiz_settings');


var createQuizFrame = require('./create_quiz_frame');
var createExamFrame = require('./create_exam_frame');
var createChapterQuizFrame = require('./create_chapter_quiz_frame');

var createDiagFrame = require('./create_diag_frame');


var DermPath = require('./dermpath');
var SlideStudy = require('./slide_study');
var FlashCard = require('./flashcard');
var CaseStudy = require('./case_study');

audioplugin(flowplayer);
window.flowplayer = flowplayer;
window.swiper = swiper;
window._ = lodash;
window.DermPath = DermPath;
window.SlideStudy = SlideStudy;
window.FlashCard = FlashCard;
window.CaseStudy = CaseStudy;

window.disablePrevious= function() {
    $('button.previous').attr('disabled','disabled');
};
window.enablePrevious = function() {
    $('button.previous').removeAttr('disabled');
};
window.disableNext = function () {
    $('button.next').attr('disabled','disabled');
};
window.enableNext = function () {
    $('button.next').removeAttr('disabled');
};

$(document).ready(function() {

    if (typeof clip == 'object') {
        if ($('#fp-audio').length) {
            flowplayer('#fp-audio',{
                audioOnly:true,
                autoplay:false,
                clip:clip
            });
        }
        if ($('#fp-video').length) {
            flowplayer('#fp-video',{
                audioOnly:false,
                autoplay:false,
                clip:clip
            })
        }
    }

    var swiperContainer = $('.workshop-swiper-container');
    if (swiperContainer.length) {
        var galleryTop = new Swiper('.gallery-top', {
            nextButton: '.swiper-button-next',
            prevButton: '.swiper-button-prev',
            spaceBetween: 10,
        });
        var galleryThumbs = new Swiper('.gallery-thumbs', {
            spaceBetween: 10,
            centeredSlides: true,
            slidesPerView: 'auto',
            touchRatio: 0.2,
            slideToClickedSlide: true
        });
        galleryTop.params.control = galleryThumbs;
        galleryThumbs.params.control = galleryTop;
    }
    var chapterListForm = $('.chapters_dropdown');
    if (chapterListForm.length) {
        _.forEach(chapterListForm,function(form) {
            $(form).submit(function(event) {
                event.preventDefault();
            });
            $(form).find('.jump-to-page').on('change',function() {
                var url = this.options[this.selectedIndex].value;
                if (url.length) {
                    document.location.href = url;
                }
            });

        })
    }

    var newExam = $('#new-exam-button');
    if (newExam.length) {
        $(newExam).click(function() {
            var modalDiv = $('#myModal');
            modalDiv.html('');
            var modalContent = createExamFrame();
            $(modalContent).find('#select-exam').change(function () {
                if ($(this).val()=='Core'){
                    $(modalContent).find('#exam-module-block').removeClass('hidden');
                }else{
                    $(modalContent).find('#exam-module-block').addClass('hidden');
                }
            });
            $(modalContent).find('#create-exam-button').click(function() {
                var examType = $('#select-exam').val();
                var examModule= $('#select-module').val();
                if(examType==''){
                    alert('Please make sure you select exam type.');
                    return false;
                }
                var url = apiUrl + 'practiceExam/create/'
                $.ajax({
                    url: url,
                    data: { userId : userId, type: examType, module: examModule},
                    dataType: 'json',
                    success:function(response) {
                        if (response.status) {
                            $('#myModal').modal('hide');
                        }
                        document.location.href  = '/exam/?examId=' + response.examId + '&userId=' + userId;
                    }
                });
            });
            $(modalDiv).append(modalContent);
            $(modalDiv).modal();
        });
    }
    var newQuiz = $('#new-quiz-button');
    if (newQuiz.length) {
        $(newQuiz).click(function() {
            var modalDiv = $('#myModal');
            modalDiv.html('');
            var modalContent = createQuizFrame();
            $(modalContent).find('#select-quiz, #select-exam').on('change',function() {
                var quizType = $('#select-quiz').val();
                var quizName = $('#select-quiz option')[$('#select-quiz')[0].selectedIndex].innerText;
                $(modalContent).find('.quiz-name-group').css('display','block');
                $(modalContent).find('#quiz-name').val(quizName);
                var tableWrapper = $(modalContent).find('.settings-table-wrapper');
                var settingsDom = $(modalContent).find('.quiz-custom-settings');


                if (quizType==='custom') {
                    settingsDom.css('display','block');

                    var examType=$('#select-exam').val();
                    // go get stats and make the table
                    $.ajax({
                        url: apiUrl + 'quiz/'+ userId +'/getQuizStats',
                        data: { questionType: 'all', examType:examType},
                        dataType:'json',
                        success:function(response) {
                            var quiz_settings = quizSettings(response);
                            tableWrapper.html('');
                            tableWrapper.append(quiz_settings);

                            $('.quiz-custom-settings').find('#question-type').on('change',function() {
                                var questionType = $('#question-type').val();
                                setQuizSettings(tableWrapper,questionType,examType);
                            });
                        }
                    });

                } else {
                    // set the question type to all
                    $(modalContent).find('#question-type')[0].selectedIndex = 0;
                    tableWrapper.html('');
                    settingsDom.css('display','none');

                }
            });
            $(modalContent).find('#create-quiz-button').click(function() {
                var examType = $('#select-exam').val();
                if(examType==''){
                    alert('Please make sure you select exam type.');
                    return false;
                }
                var quizType = $('#select-quiz').val();
                var name = $('#quiz-name').val();
                var data = { userId : userId, name: name, chapters:[], examType: examType};
                var total = 0;

                if (quizType === 'custom') {

                    data.type = $('#question-type').val();

                    if ($('#all_chapters').prop('checked')===true) {
                        data.all_chapters = 'on';
                        data.all_chapters_num = $('#all_chapters_num').val();
                        total = data.all_chapters_num;
                    } else {
                        $('.select_chapter:checked').each(function() {
                            var id = $(this).val();
                            var val = $('#num_'+id).val();
                            data.chapters.push({ id: id, num: val});
                            total += val;
                        });
                    }
                } else {
                    data.type=quizType;
                    total = 1; // just something with a value
                }
                if (total == 0 ) {
                    alert('Please choose a number of questions.');
                } else {
                    var url = apiUrl + 'quiz/create/';
                    $.ajax({
                        url: url,
                        data: data,
                        dataType: 'json',
                        success:function(response) {
                            if (response.status) {
                                $('#myModal').modal('hide');
                            }
                            document.location.href  = '/quiz/?quizId=' + response.quizId + '&userId=' + userId;
                        }
                    });

                }

            });
            $(modalDiv).append(modalContent);
            $(modalDiv).modal();

        });
    }
    var newDiag = $('#new-diag-button');
    if (newDiag.length) {
        $(newDiag).click(function() {
            var modalDiv = $('#myModal');
            modalDiv.html('');
            var modalContent = createDiagFrame();
            $(modalContent).find('#create-diag-button').click(function() {
                var quizType = $('#select-quiz').val();
                var name = $('#diag-name').val();
                var data = { userId : userId, name: name, type: "diagnostic"};
                var total = 0;

                var url = apiUrl + 'quiz/create/';
                $.ajax({
                    url: url,
                    data: data,
                    dataType: 'json',
                    success:function(response) {
                        if (response.status) {
                            $('#myModal').modal('hide');
                        }
                        document.location.href  = '/quiz/?quizId=' + response.quizId + '&userId=' + userId;
                    }
                });

            });
            $(modalDiv).append(modalContent);
            $(modalDiv).modal();

        });
    }
    function setQuizSettings(settingsDom,type,examType) {
        settingsDom.html('');

        $.ajax({
            url: apiUrl + 'quiz/'+ userId +'/getQuizStats',
            data: { questionType: type, examType:examType},
            dataType:'json',
            success:function(response) {
                var quiz_settings = quizSettings(response);
                settingsDom.append(quiz_settings);
            }
        });
    }
    var chapterQuiz = $('.chapter-quiz');
    if (chapterQuiz.length) {
        $(chapterQuiz).click(function() {
            var chapter_id = $(this).attr('data');
            var quizName = $(this).attr('title');
            var modalDiv = $('#myModal');
            modalDiv.html('');
            var examType='';
            var modalContent = createChapterQuizFrame();
            $(modalContent).find('#quiz-name').val(quizName);
            $.ajax({
                url: apiUrl + 'quiz/'+ userId +'/getQuizStats',
                data: { questionType: 'all', examType:examType},
                dataType:'json',
                success:function(response) {
                    var tableWrapper = $(modalContent).find('.settings-table-wrapper');
                    var quiz_settings = chapterQuizSettings(response,chapter_id);
                    tableWrapper.append(quiz_settings);
                }
            });
            $(modalContent).find('#create-quiz-button').click(function() {
                var name = $('#quiz-name').val();
                var examType = $('#select-exam').val();
                if(examType==''){
                    alert('Please make sure you select exam type.');
                    return false;
                }
                var data = { userId : userId, name: name, chapters:[],type:'all', examType:examType};

                var val = $('#num_'+chapter_id).val();
                data.chapters.push({ id: chapter_id, num: val});


                var url = apiUrl + 'quiz/create/';
                $.ajax({
                    url: url,
                    data: data,
                    dataType: 'json',
                    success:function(response) {
                        if (response.status) {
                            $('#myModal').modal('hide');
                        }
                        document.location.href  = '/quiz/?quizId=' + response.quizId + '&userId=' + userId;
                    }
                });
            });
            $(modalDiv).append(modalContent);
            $(modalDiv).modal();
            $(modalContent).find('#create-quiz-button').click(function() {
                var examType = $('#select-exam').val();
                if(examType==''){
                    alert('Please make sure you select exam type.');
                    return false;
                }
                var name = $('#quiz-name').val();
                var data = { userId : userId, name: name, chapters:[],type:'all', examType:examType};

                var val = $('#num_'+chapter_id).val();
                data.chapters.push({ id: chapter_id, num: val});


                var url = apiUrl + 'quiz/create/';
                $.ajax({
                    url: url,
                    data: data,
                    dataType: 'json',
                    success:function(response) {
                        if (response.status) {
                            $('#myModal').modal('hide');
                        }
                        document.location.href  = '/quiz/?quizId=' + response.quizId + '&userId=' + userId;
                    }
                });
            });
            $(modalDiv).append(modalContent);
            $(modalDiv).modal();
        });
    }
    if ($('#chapter-study-modal').length) {
        $('#chapter-study-modal').modal();
    }

});



//////////////////
// WEBPACK FOOTER
// ./src/dir.js
// module id = 226
// module chunks = 0